export default {
	// Tab labels
	assetsWithDefects: "Assets with Defects",
	repairs: "Repairs",
	repairTime: "Repair Time",

	// Page titles
	assetsWithOpenDefects: "Assets with Open Defects",
	repairsReport: "Repairs Report",
	repairTimeReport: "Repair Time Report",
	openDefectDetails: "Open Defect Details",
	defectsFor: "Defects for {assetFleet}",

	// Column headers
	asset: "Asset",
	homeLocation: "Home Location",
	type: "Type",
	manufacturer: "Manufacturer",
	vin: "VIN",
	lastInspection: "Last Inspection",
	currentZone: "Current Zone",
	status: "Status",
	defects: "Defects",
	actions: "Actions",
	zone: "Zone",
	component: "Component",
	condition: "Condition",
	severity: "Severity",
	mechanic: "Mechanic",
	soNumber: "S.O. Number",
	inspectionDate: "Inspection Date",
	count: "Count",
	tags: "Tags",

	// Filter labels
	configType: "Inspection Type",
	allTypes: "All Types",
	location: "Location",
	assetType: "Asset Type",
	allAssetTypes: "All Asset Types",
	defectStatus: "Defect Status",
	showAll: "Show all",
	open: "Open",
	pending: "Pending",
	allZones: "All Zones",
	allComponents: "All Components",
	allConditions: "All Conditions",
	startDate: "Start Date",
	endDate: "End Date",
	clear: "Clear",
	typeToSearch: "Type to search...",
	noLocationsFound: "No locations found",
	noLocationsAvailable: "No locations available",
	noAssetsFound: "No assets found",
	noAssetsAvailable: "No assets available",
	noZonesFound: "No zones found",
	noComponentsFound: "No components found",
	noConditionsFound: "No conditions found",
	closedStatus: "Closed",

	// Button labels
	exportCSV: "Export CSV",
	view: "View",
	viewDefects: "View Defects",
	back: "Back",
	repairSelected: "Repair Selected ({count})",
	addRepair: "Add Repair",
	collapse: "Collapse",
	expand: "Expand",

	// Summary card labels
	criticalDefects: "Critical Defects",
	nonCriticalDefects: "Non-Critical Defects",
	totalDefects: "Total Defects",
	criticalRepairs: "Critical Repairs",
	nonCriticalRepairs: "Non-Critical Repairs",
	totalRepairs: "Total Repairs",
	averageRepairTime: "Average Repair Time",
	fastestRepair: "Fastest Repair",
	longestRepair: "Longest Repair",

	// Severity labels
	critical: "Critical",
	nonCritical: "Non-Critical",

	// Empty states
	noAssetsWithOpenDefects: "No assets with open defects",
	tryAdjustingFilters: "Try adjusting your filters",
	noRepairsFound: "No repairs found",
	tryAdjustingDateRange: "Try adjusting your date range or filters",
	noRepairDataFound: "No repair data found",
	noOpenDefects: "No open defects",
	allDefectsResolved: "All defects have been resolved",

	// Expanded row content
	repairNotes: "Repair Notes",
	noNotesProvided: "No notes provided",

	// Misc
	assets: "assets",
	noGps: "No GPS",
	na: "N/A",

	pending: "Pending",
	repairNotNeeded: "Repair not needed",
	repaired: "Repaired",
};
